import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: any;
};

export type Account = {
  __typename?: 'Account';
  canHaveCompany?: Maybe<Scalars['Boolean']>;
  hasCompany?: Maybe<Scalars['Boolean']>;
  hasName?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type AuthenticateInput = {
  token: Scalars['String'];
};

export type Block = {
  __typename?: 'Block';
  color?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  hidden?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sub?: Maybe<Scalars['String']>;
  sup?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type BlockInput = {
  color?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  sub?: InputMaybe<Scalars['String']>;
  sup?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type Bookmark = {
  __typename?: 'Bookmark';
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  ownerId: Scalars['ID'];
  profileId: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type Comment = {
  __typename?: 'Comment';
  author: Profile;
  authorId: Scalars['String'];
  id: Scalars['String'];
  message: Scalars['String'];
};

export type Company = {
  __typename?: 'Company';
  blocks: Array<Block>;
  description: Scalars['String'];
  domains: Array<Scalars['String']>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  name: Scalars['String'];
  photo: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type CompanySuggestion = {
  __typename?: 'CompanySuggestion';
  autojoin: Scalars['Boolean'];
  domain: Scalars['String'];
  name: Scalars['String'];
  profileId: Scalars['String'];
};

export type Contact = {
  __typename?: 'Contact';
  createdAt: Scalars['Date'];
  group?: Maybe<Group>;
  id: Scalars['ID'];
  match?: Maybe<Match>;
  method: Scalars['String'];
  owner: Profile;
  ownerId: Scalars['ID'];
  target: Profile;
  targetId: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type CreateCompanyInput = {
  description: Scalars['String'];
  name: Scalars['String'];
  photo?: InputMaybe<Scalars['String']>;
};

export type CreateContactInput = {
  method?: InputMaybe<Scalars['String']>;
  targetId: Scalars['ID'];
};

export type CreateGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  photo?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<GroupPrivacy>;
};

export type CreateMeetingInput = {
  date: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  duration: Scalars['Int'];
  inviteeId: Scalars['ID'];
  title: Scalars['String'];
};

export type Element = {
  __typename?: 'Element';
  color: Scalars['String'];
  content: Scalars['String'];
  createdAt: Scalars['Date'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  sub: Scalars['String'];
  sup: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  url: Scalars['String'];
};

export type ElementCollection = {
  __typename?: 'ElementCollection';
  elements: Array<Element>;
  id: Scalars['ID'];
  parentId: Scalars['ID'];
};

export type ElementInput = {
  color: Scalars['String'];
  content: Scalars['String'];
  icon: Scalars['String'];
  sub: Scalars['String'];
  sup: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type Group = {
  __typename?: 'Group';
  blocks: Array<Block>;
  description: Scalars['String'];
  id: Scalars['ID'];
  invites: Array<GroupInvite>;
  members: Array<GroupMember>;
  membership?: Maybe<GroupMember>;
  name: Scalars['String'];
  photo: Scalars['String'];
  privacy: GroupPrivacy;
};


export type GroupMembersArgs = {
  industry?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type GroupInfo = {
  __typename?: 'GroupInfo';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  photo: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type GroupInvite = {
  __typename?: 'GroupInvite';
  group: GroupInfo;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  profile: Profile;
  profileId: Scalars['ID'];
};

export type GroupMember = {
  __typename?: 'GroupMember';
  contact?: Maybe<Contact>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  match?: Maybe<Match>;
  profile: Profile;
  profileId: Scalars['ID'];
  role: Scalars['String'];
};

export enum GroupPrivacy {
  Private = 'private',
  Public = 'public'
}

export type GroupTags = {
  __typename?: 'GroupTags';
  id: Scalars['ID'];
  industry: Array<Scalars['String']>;
  location: Array<Scalars['String']>;
};

export type JoinGroupResponse = {
  __typename?: 'JoinGroupResponse';
  invite?: Maybe<GroupInvite>;
  member?: Maybe<GroupMember>;
};

export type MagicLinkInput = {
  email: Scalars['String'];
  redirectUrl?: InputMaybe<Scalars['String']>;
};

export type Match = {
  __typename?: 'Match';
  createdAt: Scalars['String'];
  group: Group;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  receiver: Profile;
  receiverId: Scalars['ID'];
  sender: Profile;
  senderId: Scalars['ID'];
  status: MatchStatus;
};

export type MatchInput = {
  groupId: Scalars['ID'];
  receiverId: Scalars['ID'];
};

export enum MatchStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Meeting = {
  __typename?: 'Meeting';
  createdAt: Scalars['String'];
  date: Scalars['String'];
  dateTime: Scalars['String'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  invitee: Profile;
  inviter: Profile;
  location?: Maybe<Scalars['String']>;
  status: MeetingStatus;
};

export enum MeetingStatus {
  Accepted = 'ACCEPTED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptGroupInvite?: Maybe<Scalars['Boolean']>;
  archiveGroup?: Maybe<Group>;
  authenticate: Scalars['Boolean'];
  checkProfileIdentifierAvailable: Scalars['Boolean'];
  createBookmark: Bookmark;
  createComment: Comment;
  createCompany?: Maybe<Company>;
  createContact: Contact;
  createElement: Element;
  createGroup: Group;
  createMagicLink: Scalars['Boolean'];
  createMatch: Match;
  createMeeting: Meeting;
  joinGroup: JoinGroupResponse;
  leaveGroup: Scalars['Boolean'];
  rejectGroupInvite?: Maybe<Scalars['Boolean']>;
  removeComment: Comment;
  removeElement: Element;
  removeGroupMember: Scalars['Boolean'];
  removeMatch: Match;
  requestAccount: Scalars['Boolean'];
  revokeGroupInvite?: Maybe<Scalars['Boolean']>;
  suggestCompanyName: CompanySuggestion;
  updateBookmark: Scalars['Boolean'];
  updateCompany: Company;
  updateElement: Element;
  updateGroup: Group;
  updateMeetingStatus: Meeting;
  updateProfile: Profile;
};


export type MutationAcceptGroupInviteArgs = {
  inviteId: Scalars['ID'];
};


export type MutationArchiveGroupArgs = {
  id: Scalars['ID'];
};


export type MutationAuthenticateArgs = {
  input: AuthenticateInput;
};


export type MutationCheckProfileIdentifierAvailableArgs = {
  identifier?: InputMaybe<Scalars['String']>;
};


export type MutationCreateBookmarkArgs = {
  groupId: Scalars['ID'];
  profileId: Scalars['ID'];
};


export type MutationCreateCommentArgs = {
  blockId: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateElementArgs = {
  input: ElementInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateMagicLinkArgs = {
  input: MagicLinkInput;
};


export type MutationCreateMatchArgs = {
  input: MatchInput;
};


export type MutationCreateMeetingArgs = {
  input: CreateMeetingInput;
};


export type MutationJoinGroupArgs = {
  groupId: Scalars['ID'];
};


export type MutationLeaveGroupArgs = {
  groupId: Scalars['ID'];
};


export type MutationRejectGroupInviteArgs = {
  inviteId: Scalars['ID'];
};


export type MutationRemoveCommentArgs = {
  blockId: Scalars['ID'];
};


export type MutationRemoveElementArgs = {
  elementId: Scalars['ID'];
};


export type MutationRemoveGroupMemberArgs = {
  groupId: Scalars['ID'];
  profileId: Scalars['ID'];
};


export type MutationRemoveMatchArgs = {
  matchId: Scalars['ID'];
};


export type MutationRequestAccountArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  username: Scalars['String'];
};


export type MutationRevokeGroupInviteArgs = {
  inviteId: Scalars['ID'];
};


export type MutationUpdateBookmarkArgs = {
  groupId: Scalars['ID'];
  profileId: Scalars['ID'];
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateElementArgs = {
  elementId: Scalars['ID'];
  input: ElementInput;
};


export type MutationUpdateGroupArgs = {
  id: Scalars['ID'];
  input: UpdateGroupInput;
};


export type MutationUpdateMeetingStatusArgs = {
  input: UpdateMeetingStatusInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};

export type Notifications = {
  __typename?: 'Notifications';
  invites: Array<GroupInvite>;
  matches: Array<Match>;
};

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Profile = {
  __typename?: 'Profile';
  audio?: Maybe<Scalars['String']>;
  blocks: Array<Block>;
  company?: Maybe<Company>;
  email: Scalars['String'];
  id: Scalars['ID'];
  identifier: Scalars['String'];
  industry?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  photo: Scalars['String'];
  role: Scalars['String'];
  socialDribble?: Maybe<Scalars['String']>;
  socialEmail?: Maybe<Scalars['String']>;
  socialInstagram?: Maybe<Scalars['String']>;
  socialLinkedIn?: Maybe<Scalars['String']>;
  socialPhone?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
  visible: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  bookmarks: Array<Bookmark>;
  collection?: Maybe<ElementCollection>;
  comments: Array<Comment>;
  company?: Maybe<Company>;
  contacts: Array<Contact>;
  employees: Array<Profile>;
  getMeetingsForProfile?: Maybe<Array<Meeting>>;
  group?: Maybe<Group>;
  groupInfo?: Maybe<GroupInfo>;
  groupTags: GroupTags;
  groups: Array<Group>;
  invites: Array<GroupInvite>;
  matches?: Maybe<Array<Match>>;
  meeting: Meeting;
  meetings?: Maybe<Array<Meeting>>;
  notifications: Notifications;
  profile?: Maybe<Profile>;
  self?: Maybe<Profile>;
};


export type QueryBookmarksArgs = {
  groupId: Scalars['ID'];
};


export type QueryCollectionArgs = {
  parentId: Scalars['ID'];
};


export type QueryCommentsArgs = {
  blockId: Scalars['ID'];
};


export type QueryCompanyArgs = {
  identifier: Scalars['String'];
};


export type QueryEmployeesArgs = {
  identifier: Scalars['String'];
  page?: InputMaybe<Pagination>;
};


export type QueryGetMeetingsForProfileArgs = {
  id: Scalars['ID'];
};


export type QueryGroupArgs = {
  id: Scalars['ID'];
};


export type QueryGroupInfoArgs = {
  id: Scalars['ID'];
};


export type QueryGroupTagsArgs = {
  id: Scalars['ID'];
};


export type QueryMatchesArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<MatchStatus>;
};


export type QueryMeetingArgs = {
  meetingId: Scalars['ID'];
};


export type QueryProfileArgs = {
  slug?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  contactCreated: Contact;
  matched: Match;
};


export type SubscriptionContactCreatedArgs = {
  profileId: Scalars['ID'];
};


export type SubscriptionMatchedArgs = {
  profileId: Scalars['ID'];
};

export type Tag = {
  __typename?: 'Tag';
  text: Scalars['String'];
  type: Scalars['String'];
};

export type TagInput = {
  text: Scalars['String'];
  type: Scalars['String'];
};

export type UpdateCompanyInput = {
  blocks?: InputMaybe<Array<BlockInput>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateGroupInput = {
  blocks?: InputMaybe<Array<BlockInput>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['String']>;
};

export type UpdateMeetingStatusInput = {
  meetingId: Scalars['ID'];
  status: MeetingStatus;
};

export type UpdateProfileInput = {
  blocks?: InputMaybe<Array<BlockInput>>;
  identifier?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  socialDribble?: InputMaybe<Scalars['String']>;
  socialEmail?: InputMaybe<Scalars['String']>;
  socialInstagram?: InputMaybe<Scalars['String']>;
  socialLinkedIn?: InputMaybe<Scalars['String']>;
  socialPhone?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type AcceptGroupInviteMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type AcceptGroupInviteMutation = { __typename?: 'Mutation', acceptGroupInvite?: boolean | null };

export type ArchiveGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveGroupMutation = { __typename?: 'Mutation', archiveGroup?: { __typename?: 'Group', id: string } | null };

export type AuthenticateMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate: boolean };

export type CreateBookmarkMutationVariables = Exact<{
  groupId: Scalars['ID'];
  profileId: Scalars['ID'];
}>;


export type CreateBookmarkMutation = { __typename?: 'Mutation', createBookmark: { __typename?: 'Bookmark', id: string } };

export type CreateCommentMutationVariables = Exact<{
  blockId: Scalars['ID'];
  message: Scalars['String'];
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', id: string, message: string } };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'Contact', id: string, target: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string } } };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: string, name: string, description: string, photo: string, privacy: GroupPrivacy, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, members: Array<{ __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> } };

export type CreateMagicLinkMutationVariables = Exact<{
  input: MagicLinkInput;
}>;


export type CreateMagicLinkMutation = { __typename?: 'Mutation', createMagicLink: boolean };

export type CreateMatchMutationVariables = Exact<{
  groupId: Scalars['ID'];
  receiverId: Scalars['ID'];
}>;


export type CreateMatchMutation = { __typename?: 'Mutation', createMatch: { __typename?: 'Match', id: string, status: MatchStatus } };

export type GetBookmarksQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GetBookmarksQuery = { __typename?: 'Query', bookmarks: Array<{ __typename?: 'Bookmark', id: string, profileId: string }> };

export type GetCommentsQueryVariables = Exact<{
  blockId: Scalars['ID'];
}>;


export type GetCommentsQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'Comment', id: string, message: string, author: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string } }> };

export type GetCompanyQueryVariables = Exact<{
  identifier: Scalars['String'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string, visible: boolean, domains: Array<string>, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }> } | null, employees: Array<{ __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string }> };

export type GetContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'Contact', id: string, target: { __typename?: 'Profile', id: string, identifier: string, name: string, photo: string, role: string, industry?: string | null, location?: string | null }, group?: { __typename?: 'Group', id: string, name: string, photo: string } | null }> };

export type GetEditGroupPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEditGroupPageQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, name: string, description: string, photo: string, privacy: GroupPrivacy, membership?: { __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } } | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, members: Array<{ __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> } | null };

export type GetGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetGroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, name: string, description: string, photo: string, privacy: GroupPrivacy, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, members: Array<{ __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> } | null };

export type GetGroupInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetGroupInfoQuery = { __typename?: 'Query', groupInfo?: { __typename?: 'GroupInfo', id: string, name: string, description: string, photo: string, status?: string | null } | null };

export type GetGroupInvitesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetGroupInvitesQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, invites: Array<{ __typename?: 'GroupInvite', id: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> } | null };

export type GetGroupMembersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetGroupMembersQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, members: Array<{ __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }>, invites: Array<{ __typename?: 'GroupInvite', id: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> } | null };

export type GetGroupMembersPageQueryVariables = Exact<{
  id: Scalars['ID'];
  industry?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
}>;


export type GetGroupMembersPageQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, members: Array<{ __typename?: 'GroupMember', id: string, role: string, contact?: { __typename?: 'Contact', id: string } | null, match?: { __typename?: 'Match', id: string, status: MatchStatus, senderId: string } | null, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> } | null };

export type GetGroupPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetGroupPageQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, name: string, description: string, photo: string, privacy: GroupPrivacy, membership?: { __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } } | null, invites: Array<{ __typename?: 'GroupInvite', id: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }>, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, members: Array<{ __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> } | null };

export type GetGroupTagsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetGroupTagsQuery = { __typename?: 'Query', groupTags: { __typename?: 'GroupTags', id: string, location: Array<string>, industry: Array<string> } };

export type GetGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsQuery = { __typename?: 'Query', groups: Array<{ __typename?: 'Group', id: string, name: string, description: string, photo: string, privacy: GroupPrivacy, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, members: Array<{ __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> }> };

export type GetHomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomePageQuery = { __typename?: 'Query', groups: Array<{ __typename?: 'Group', id: string, name: string, description: string, photo: string }>, contacts: Array<{ __typename?: 'Contact', id: string, target: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string } }>, invites: Array<{ __typename?: 'GroupInvite', id: string, group: { __typename?: 'GroupInfo', name: string, photo: string } }> };

export type GetMatchesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMatchesQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, name: string, description: string, photo: string, privacy: GroupPrivacy, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, members: Array<{ __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> } | null, matches?: Array<{ __typename?: 'Match', receiverId: string, senderId: string, id: string, status: MatchStatus }> | null };

export type MatchFragment = { __typename?: 'Match', receiverId: string, senderId: string, id: string, status: MatchStatus };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'Notifications', invites: Array<{ __typename?: 'GroupInvite', id: string, group: { __typename?: 'GroupInfo', id: string, name: string, photo: string }, profile: { __typename?: 'Profile', id: string, identifier: string, name: string, photo: string } }>, matches: Array<{ __typename?: 'Match', id: string, group: { __typename?: 'Group', id: string, name: string, photo: string }, sender: { __typename?: 'Profile', id: string, name: string, photo: string, identifier: string, role: string, company?: { __typename?: 'Company', id: string, identifier: string, name: string } | null } }> } };

export type GetProfileQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } | null };

export type GetSelfQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelfQuery = { __typename?: 'Query', self?: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string, visible: boolean, domains: Array<string>, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }> } | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }> } | null };

export type JoinGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type JoinGroupMutation = { __typename?: 'Mutation', joinGroup: { __typename?: 'JoinGroupResponse', invite?: { __typename?: 'GroupInvite', id: string } | null, member?: { __typename?: 'GroupMember', id: string } | null } };

export type RejectGroupInviteMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type RejectGroupInviteMutation = { __typename?: 'Mutation', rejectGroupInvite?: boolean | null };

export type RemoveCommentMutationVariables = Exact<{
  blockId: Scalars['ID'];
}>;


export type RemoveCommentMutation = { __typename?: 'Mutation', removeComment: { __typename?: 'Comment', id: string } };

export type RemoveGroupMemberMutationVariables = Exact<{
  groupId: Scalars['ID'];
  profileId: Scalars['ID'];
}>;


export type RemoveGroupMemberMutation = { __typename?: 'Mutation', removeGroupMember: boolean };

export type RemoveMatchMutationVariables = Exact<{
  matchId: Scalars['ID'];
}>;


export type RemoveMatchMutation = { __typename?: 'Mutation', removeMatch: { __typename?: 'Match', id: string } };

export type RequestAccountMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  username: Scalars['String'];
}>;


export type RequestAccountMutation = { __typename?: 'Mutation', requestAccount: boolean };

export type UpdateBookmarkMutationVariables = Exact<{
  groupId: Scalars['ID'];
  profileId: Scalars['ID'];
}>;


export type UpdateBookmarkMutation = { __typename?: 'Mutation', updateBookmark: boolean };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string, visible: boolean, domains: Array<string>, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }> } };

export type UpdateGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'Group', id: string, name: string, description: string, photo: string, privacy: GroupPrivacy, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, members: Array<{ __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> } };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } };

export type BlockFragment = { __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null };

export type CompanyFragment = { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string, visible: boolean, domains: Array<string>, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }> };

export type CompanySummaryFragment = { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string };

export type ContactFragment = { __typename?: 'Contact', id: string, target: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string } };

export type GroupFragment = { __typename?: 'Group', id: string, name: string, description: string, photo: string, privacy: GroupPrivacy, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, members: Array<{ __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } }> };

export type GroupInviteFragment = { __typename?: 'GroupInvite', id: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } };

export type GroupMemberFragment = { __typename?: 'GroupMember', id: string, role: string, profile: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null } };

export type GroupSummaryFragment = { __typename?: 'Group', id: string, name: string, description: string, photo: string };

export type ProfileFragment = { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string, audio?: string | null, visible: boolean, industry?: string | null, location?: string | null, socialLinkedIn?: string | null, socialInstagram?: string | null, socialPhone?: string | null, socialEmail?: string | null, socialDribble?: string | null, blocks: Array<{ __typename?: 'Block', id: string, type: string, sub?: string | null, sup?: string | null, color?: string | null, icon?: string | null, content: string, url?: string | null }>, company?: { __typename?: 'Company', id: string, identifier: string, name: string, photo: string, description: string } | null };

export type ProfileSummaryFragment = { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string };

export type TagFragment = { __typename?: 'Tag', type: string, text: string };

export type OnContactCreatedSubscriptionVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type OnContactCreatedSubscription = { __typename?: 'Subscription', contactCreated: { __typename?: 'Contact', id: string, target: { __typename?: 'Profile', id: string, email: string, identifier: string, photo: string, name: string, role: string } } };

export type OnMatchSubscriptionVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type OnMatchSubscription = { __typename?: 'Subscription', matched: { __typename?: 'Match', receiverId: string, senderId: string, id: string, status: MatchStatus } };

export const MatchFragmentDoc = gql`
    fragment Match on Match {
  receiverId
  senderId
  id
  status
}
    `;
export const BlockFragmentDoc = gql`
    fragment Block on Block {
  id
  type
  sub
  sup
  color
  icon
  content
  url
}
    `;
export const CompanyFragmentDoc = gql`
    fragment Company on Company {
  id
  identifier
  name
  photo
  description
  visible
  domains
  blocks {
    ...Block
  }
}
    ${BlockFragmentDoc}`;
export const ProfileSummaryFragmentDoc = gql`
    fragment ProfileSummary on Profile {
  id
  email
  identifier
  photo
  name
  role
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on Contact {
  id
  target {
    ...ProfileSummary
  }
}
    ${ProfileSummaryFragmentDoc}`;
export const CompanySummaryFragmentDoc = gql`
    fragment CompanySummary on Company {
  id
  identifier
  name
  photo
  description
}
    `;
export const ProfileFragmentDoc = gql`
    fragment Profile on Profile {
  id
  email
  identifier
  photo
  name
  role
  audio
  visible
  industry
  location
  socialLinkedIn
  socialInstagram
  socialPhone
  socialEmail
  socialDribble
  blocks {
    ...Block
  }
  company {
    ...CompanySummary
  }
}
    ${BlockFragmentDoc}
${CompanySummaryFragmentDoc}`;
export const GroupMemberFragmentDoc = gql`
    fragment GroupMember on GroupMember {
  id
  role
  profile {
    ...Profile
  }
}
    ${ProfileFragmentDoc}`;
export const GroupFragmentDoc = gql`
    fragment Group on Group {
  id
  name
  description
  photo
  privacy
  blocks {
    ...Block
  }
  members {
    ...GroupMember
  }
}
    ${BlockFragmentDoc}
${GroupMemberFragmentDoc}`;
export const GroupInviteFragmentDoc = gql`
    fragment GroupInvite on GroupInvite {
  id
  profile {
    ...Profile
  }
}
    ${ProfileFragmentDoc}`;
export const GroupSummaryFragmentDoc = gql`
    fragment GroupSummary on Group {
  id
  name
  description
  photo
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  type
  text
}
    `;
export const AcceptGroupInviteDocument = gql`
    mutation AcceptGroupInvite($inviteId: ID!) {
  acceptGroupInvite(inviteId: $inviteId)
}
    `;
export type AcceptGroupInviteMutationFn = Apollo.MutationFunction<AcceptGroupInviteMutation, AcceptGroupInviteMutationVariables>;

/**
 * __useAcceptGroupInviteMutation__
 *
 * To run a mutation, you first call `useAcceptGroupInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptGroupInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptGroupInviteMutation, { data, loading, error }] = useAcceptGroupInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useAcceptGroupInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptGroupInviteMutation, AcceptGroupInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptGroupInviteMutation, AcceptGroupInviteMutationVariables>(AcceptGroupInviteDocument, options);
      }
export type AcceptGroupInviteMutationHookResult = ReturnType<typeof useAcceptGroupInviteMutation>;
export type AcceptGroupInviteMutationResult = Apollo.MutationResult<AcceptGroupInviteMutation>;
export type AcceptGroupInviteMutationOptions = Apollo.BaseMutationOptions<AcceptGroupInviteMutation, AcceptGroupInviteMutationVariables>;
export const ArchiveGroupDocument = gql`
    mutation ArchiveGroup($id: ID!) {
  archiveGroup(id: $id) {
    id
  }
}
    `;
export type ArchiveGroupMutationFn = Apollo.MutationFunction<ArchiveGroupMutation, ArchiveGroupMutationVariables>;

/**
 * __useArchiveGroupMutation__
 *
 * To run a mutation, you first call `useArchiveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveGroupMutation, { data, loading, error }] = useArchiveGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveGroupMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveGroupMutation, ArchiveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveGroupMutation, ArchiveGroupMutationVariables>(ArchiveGroupDocument, options);
      }
export type ArchiveGroupMutationHookResult = ReturnType<typeof useArchiveGroupMutation>;
export type ArchiveGroupMutationResult = Apollo.MutationResult<ArchiveGroupMutation>;
export type ArchiveGroupMutationOptions = Apollo.BaseMutationOptions<ArchiveGroupMutation, ArchiveGroupMutationVariables>;
export const AuthenticateDocument = gql`
    mutation Authenticate($token: String!) {
  authenticate(input: {token: $token})
}
    `;
export type AuthenticateMutationFn = Apollo.MutationFunction<AuthenticateMutation, AuthenticateMutationVariables>;

/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAuthenticateMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateMutation, AuthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateMutation, AuthenticateMutationVariables>(AuthenticateDocument, options);
      }
export type AuthenticateMutationHookResult = ReturnType<typeof useAuthenticateMutation>;
export type AuthenticateMutationResult = Apollo.MutationResult<AuthenticateMutation>;
export type AuthenticateMutationOptions = Apollo.BaseMutationOptions<AuthenticateMutation, AuthenticateMutationVariables>;
export const CreateBookmarkDocument = gql`
    mutation CreateBookmark($groupId: ID!, $profileId: ID!) {
  createBookmark(groupId: $groupId, profileId: $profileId) {
    id
  }
}
    `;
export type CreateBookmarkMutationFn = Apollo.MutationFunction<CreateBookmarkMutation, CreateBookmarkMutationVariables>;

/**
 * __useCreateBookmarkMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkMutation, { data, loading, error }] = useCreateBookmarkMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useCreateBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookmarkMutation, CreateBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookmarkMutation, CreateBookmarkMutationVariables>(CreateBookmarkDocument, options);
      }
export type CreateBookmarkMutationHookResult = ReturnType<typeof useCreateBookmarkMutation>;
export type CreateBookmarkMutationResult = Apollo.MutationResult<CreateBookmarkMutation>;
export type CreateBookmarkMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkMutation, CreateBookmarkMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($blockId: ID!, $message: String!) {
  createComment(blockId: $blockId, message: $message) {
    id
    message
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($input: CreateContactInput!) {
  createContact(input: $input) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const CreateMagicLinkDocument = gql`
    mutation CreateMagicLink($input: MagicLinkInput!) {
  createMagicLink(input: $input)
}
    `;
export type CreateMagicLinkMutationFn = Apollo.MutationFunction<CreateMagicLinkMutation, CreateMagicLinkMutationVariables>;

/**
 * __useCreateMagicLinkMutation__
 *
 * To run a mutation, you first call `useCreateMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMagicLinkMutation, { data, loading, error }] = useCreateMagicLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateMagicLinkMutation, CreateMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMagicLinkMutation, CreateMagicLinkMutationVariables>(CreateMagicLinkDocument, options);
      }
export type CreateMagicLinkMutationHookResult = ReturnType<typeof useCreateMagicLinkMutation>;
export type CreateMagicLinkMutationResult = Apollo.MutationResult<CreateMagicLinkMutation>;
export type CreateMagicLinkMutationOptions = Apollo.BaseMutationOptions<CreateMagicLinkMutation, CreateMagicLinkMutationVariables>;
export const CreateMatchDocument = gql`
    mutation CreateMatch($groupId: ID!, $receiverId: ID!) {
  createMatch(input: {groupId: $groupId, receiverId: $receiverId}) {
    id
    status
  }
}
    `;
export type CreateMatchMutationFn = Apollo.MutationFunction<CreateMatchMutation, CreateMatchMutationVariables>;

/**
 * __useCreateMatchMutation__
 *
 * To run a mutation, you first call `useCreateMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatchMutation, { data, loading, error }] = useCreateMatchMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      receiverId: // value for 'receiverId'
 *   },
 * });
 */
export function useCreateMatchMutation(baseOptions?: Apollo.MutationHookOptions<CreateMatchMutation, CreateMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMatchMutation, CreateMatchMutationVariables>(CreateMatchDocument, options);
      }
export type CreateMatchMutationHookResult = ReturnType<typeof useCreateMatchMutation>;
export type CreateMatchMutationResult = Apollo.MutationResult<CreateMatchMutation>;
export type CreateMatchMutationOptions = Apollo.BaseMutationOptions<CreateMatchMutation, CreateMatchMutationVariables>;
export const GetBookmarksDocument = gql`
    query GetBookmarks($groupId: ID!) {
  bookmarks(groupId: $groupId) {
    id
    profileId
  }
}
    `;

/**
 * __useGetBookmarksQuery__
 *
 * To run a query within a React component, call `useGetBookmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarksQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetBookmarksQuery(baseOptions: Apollo.QueryHookOptions<GetBookmarksQuery, GetBookmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookmarksQuery, GetBookmarksQueryVariables>(GetBookmarksDocument, options);
      }
export function useGetBookmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookmarksQuery, GetBookmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookmarksQuery, GetBookmarksQueryVariables>(GetBookmarksDocument, options);
        }
export type GetBookmarksQueryHookResult = ReturnType<typeof useGetBookmarksQuery>;
export type GetBookmarksLazyQueryHookResult = ReturnType<typeof useGetBookmarksLazyQuery>;
export type GetBookmarksQueryResult = Apollo.QueryResult<GetBookmarksQuery, GetBookmarksQueryVariables>;
export const GetCommentsDocument = gql`
    query GetComments($blockId: ID!) {
  comments(blockId: $blockId) {
    id
    message
    author {
      ...ProfileSummary
    }
  }
}
    ${ProfileSummaryFragmentDoc}`;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export const GetCompanyDocument = gql`
    query GetCompany($identifier: String!) {
  company(identifier: $identifier) {
    ...Company
  }
  employees(identifier: $identifier) {
    ...ProfileSummary
  }
}
    ${CompanyFragmentDoc}
${ProfileSummaryFragmentDoc}`;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetContactsDocument = gql`
    query GetContacts {
  contacts {
    id
    target {
      id
      identifier
      name
      photo
      role
      industry
      location
    }
    group {
      id
      name
      photo
    }
  }
}
    `;

/**
 * __useGetContactsQuery__
 *
 * To run a query within a React component, call `useGetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
      }
export function useGetContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
export type GetContactsQueryHookResult = ReturnType<typeof useGetContactsQuery>;
export type GetContactsLazyQueryHookResult = ReturnType<typeof useGetContactsLazyQuery>;
export type GetContactsQueryResult = Apollo.QueryResult<GetContactsQuery, GetContactsQueryVariables>;
export const GetEditGroupPageDocument = gql`
    query GetEditGroupPage($id: ID!) {
  group(id: $id) {
    ...Group
    membership {
      ...GroupMember
    }
  }
}
    ${GroupFragmentDoc}
${GroupMemberFragmentDoc}`;

/**
 * __useGetEditGroupPageQuery__
 *
 * To run a query within a React component, call `useGetEditGroupPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditGroupPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditGroupPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEditGroupPageQuery(baseOptions: Apollo.QueryHookOptions<GetEditGroupPageQuery, GetEditGroupPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditGroupPageQuery, GetEditGroupPageQueryVariables>(GetEditGroupPageDocument, options);
      }
export function useGetEditGroupPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditGroupPageQuery, GetEditGroupPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditGroupPageQuery, GetEditGroupPageQueryVariables>(GetEditGroupPageDocument, options);
        }
export type GetEditGroupPageQueryHookResult = ReturnType<typeof useGetEditGroupPageQuery>;
export type GetEditGroupPageLazyQueryHookResult = ReturnType<typeof useGetEditGroupPageLazyQuery>;
export type GetEditGroupPageQueryResult = Apollo.QueryResult<GetEditGroupPageQuery, GetEditGroupPageQueryVariables>;
export const GetGroupDocument = gql`
    query GetGroup($id: ID!) {
  group(id: $id) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const GetGroupInfoDocument = gql`
    query GetGroupInfo($id: ID!) {
  groupInfo(id: $id) {
    id
    name
    description
    photo
    status
  }
}
    `;

/**
 * __useGetGroupInfoQuery__
 *
 * To run a query within a React component, call `useGetGroupInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupInfoQuery(baseOptions: Apollo.QueryHookOptions<GetGroupInfoQuery, GetGroupInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupInfoQuery, GetGroupInfoQueryVariables>(GetGroupInfoDocument, options);
      }
export function useGetGroupInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupInfoQuery, GetGroupInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupInfoQuery, GetGroupInfoQueryVariables>(GetGroupInfoDocument, options);
        }
export type GetGroupInfoQueryHookResult = ReturnType<typeof useGetGroupInfoQuery>;
export type GetGroupInfoLazyQueryHookResult = ReturnType<typeof useGetGroupInfoLazyQuery>;
export type GetGroupInfoQueryResult = Apollo.QueryResult<GetGroupInfoQuery, GetGroupInfoQueryVariables>;
export const GetGroupInvitesDocument = gql`
    query GetGroupInvites($id: ID!) {
  group(id: $id) {
    id
    invites {
      ...GroupInvite
    }
  }
}
    ${GroupInviteFragmentDoc}`;

/**
 * __useGetGroupInvitesQuery__
 *
 * To run a query within a React component, call `useGetGroupInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupInvitesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupInvitesQuery(baseOptions: Apollo.QueryHookOptions<GetGroupInvitesQuery, GetGroupInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupInvitesQuery, GetGroupInvitesQueryVariables>(GetGroupInvitesDocument, options);
      }
export function useGetGroupInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupInvitesQuery, GetGroupInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupInvitesQuery, GetGroupInvitesQueryVariables>(GetGroupInvitesDocument, options);
        }
export type GetGroupInvitesQueryHookResult = ReturnType<typeof useGetGroupInvitesQuery>;
export type GetGroupInvitesLazyQueryHookResult = ReturnType<typeof useGetGroupInvitesLazyQuery>;
export type GetGroupInvitesQueryResult = Apollo.QueryResult<GetGroupInvitesQuery, GetGroupInvitesQueryVariables>;
export const GetGroupMembersDocument = gql`
    query GetGroupMembers($id: ID!) {
  group(id: $id) {
    id
    members {
      ...GroupMember
    }
    invites {
      ...GroupInvite
    }
  }
}
    ${GroupMemberFragmentDoc}
${GroupInviteFragmentDoc}`;

/**
 * __useGetGroupMembersQuery__
 *
 * To run a query within a React component, call `useGetGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<GetGroupMembersQuery, GetGroupMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupMembersQuery, GetGroupMembersQueryVariables>(GetGroupMembersDocument, options);
      }
export function useGetGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupMembersQuery, GetGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupMembersQuery, GetGroupMembersQueryVariables>(GetGroupMembersDocument, options);
        }
export type GetGroupMembersQueryHookResult = ReturnType<typeof useGetGroupMembersQuery>;
export type GetGroupMembersLazyQueryHookResult = ReturnType<typeof useGetGroupMembersLazyQuery>;
export type GetGroupMembersQueryResult = Apollo.QueryResult<GetGroupMembersQuery, GetGroupMembersQueryVariables>;
export const GetGroupMembersPageDocument = gql`
    query GetGroupMembersPage($id: ID!, $industry: String, $location: String) {
  group(id: $id) {
    id
    members(industry: $industry, location: $location) {
      ...GroupMember
      contact {
        id
      }
      match {
        id
        status
        senderId
      }
    }
  }
}
    ${GroupMemberFragmentDoc}`;

/**
 * __useGetGroupMembersPageQuery__
 *
 * To run a query within a React component, call `useGetGroupMembersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupMembersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupMembersPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      industry: // value for 'industry'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetGroupMembersPageQuery(baseOptions: Apollo.QueryHookOptions<GetGroupMembersPageQuery, GetGroupMembersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupMembersPageQuery, GetGroupMembersPageQueryVariables>(GetGroupMembersPageDocument, options);
      }
export function useGetGroupMembersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupMembersPageQuery, GetGroupMembersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupMembersPageQuery, GetGroupMembersPageQueryVariables>(GetGroupMembersPageDocument, options);
        }
export type GetGroupMembersPageQueryHookResult = ReturnType<typeof useGetGroupMembersPageQuery>;
export type GetGroupMembersPageLazyQueryHookResult = ReturnType<typeof useGetGroupMembersPageLazyQuery>;
export type GetGroupMembersPageQueryResult = Apollo.QueryResult<GetGroupMembersPageQuery, GetGroupMembersPageQueryVariables>;
export const GetGroupPageDocument = gql`
    query GetGroupPage($id: ID!) {
  group(id: $id) {
    ...Group
    membership {
      ...GroupMember
    }
    invites {
      ...GroupInvite
    }
  }
}
    ${GroupFragmentDoc}
${GroupMemberFragmentDoc}
${GroupInviteFragmentDoc}`;

/**
 * __useGetGroupPageQuery__
 *
 * To run a query within a React component, call `useGetGroupPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupPageQuery(baseOptions: Apollo.QueryHookOptions<GetGroupPageQuery, GetGroupPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupPageQuery, GetGroupPageQueryVariables>(GetGroupPageDocument, options);
      }
export function useGetGroupPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupPageQuery, GetGroupPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupPageQuery, GetGroupPageQueryVariables>(GetGroupPageDocument, options);
        }
export type GetGroupPageQueryHookResult = ReturnType<typeof useGetGroupPageQuery>;
export type GetGroupPageLazyQueryHookResult = ReturnType<typeof useGetGroupPageLazyQuery>;
export type GetGroupPageQueryResult = Apollo.QueryResult<GetGroupPageQuery, GetGroupPageQueryVariables>;
export const GetGroupTagsDocument = gql`
    query GetGroupTags($id: ID!) {
  groupTags(id: $id) {
    id
    location
    industry
  }
}
    `;

/**
 * __useGetGroupTagsQuery__
 *
 * To run a query within a React component, call `useGetGroupTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupTagsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupTagsQuery, GetGroupTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupTagsQuery, GetGroupTagsQueryVariables>(GetGroupTagsDocument, options);
      }
export function useGetGroupTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupTagsQuery, GetGroupTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupTagsQuery, GetGroupTagsQueryVariables>(GetGroupTagsDocument, options);
        }
export type GetGroupTagsQueryHookResult = ReturnType<typeof useGetGroupTagsQuery>;
export type GetGroupTagsLazyQueryHookResult = ReturnType<typeof useGetGroupTagsLazyQuery>;
export type GetGroupTagsQueryResult = Apollo.QueryResult<GetGroupTagsQuery, GetGroupTagsQueryVariables>;
export const GetGroupsDocument = gql`
    query GetGroups {
  groups {
    ...Group
  }
}
    ${GroupFragmentDoc}`;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetHomePageDocument = gql`
    query GetHomePage {
  groups {
    ...GroupSummary
  }
  contacts {
    ...Contact
  }
  invites {
    id
    group {
      name
      photo
    }
  }
}
    ${GroupSummaryFragmentDoc}
${ContactFragmentDoc}`;

/**
 * __useGetHomePageQuery__
 *
 * To run a query within a React component, call `useGetHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomePageQuery(baseOptions?: Apollo.QueryHookOptions<GetHomePageQuery, GetHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomePageQuery, GetHomePageQueryVariables>(GetHomePageDocument, options);
      }
export function useGetHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomePageQuery, GetHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomePageQuery, GetHomePageQueryVariables>(GetHomePageDocument, options);
        }
export type GetHomePageQueryHookResult = ReturnType<typeof useGetHomePageQuery>;
export type GetHomePageLazyQueryHookResult = ReturnType<typeof useGetHomePageLazyQuery>;
export type GetHomePageQueryResult = Apollo.QueryResult<GetHomePageQuery, GetHomePageQueryVariables>;
export const GetMatchesDocument = gql`
    query GetMatches($id: ID!) {
  group(id: $id) {
    ...Group
  }
  matches(groupId: $id) {
    ...Match
  }
}
    ${GroupFragmentDoc}
${MatchFragmentDoc}`;

/**
 * __useGetMatchesQuery__
 *
 * To run a query within a React component, call `useGetMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetMatchesQuery, GetMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchesQuery, GetMatchesQueryVariables>(GetMatchesDocument, options);
      }
export function useGetMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchesQuery, GetMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchesQuery, GetMatchesQueryVariables>(GetMatchesDocument, options);
        }
export type GetMatchesQueryHookResult = ReturnType<typeof useGetMatchesQuery>;
export type GetMatchesLazyQueryHookResult = ReturnType<typeof useGetMatchesLazyQuery>;
export type GetMatchesQueryResult = Apollo.QueryResult<GetMatchesQuery, GetMatchesQueryVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications {
  notifications {
    invites {
      id
      group {
        id
        name
        photo
      }
      profile {
        id
        identifier
        name
        photo
      }
    }
    matches {
      id
      group {
        id
        name
        photo
      }
      sender {
        id
        name
        photo
        identifier
        role
        company {
          id
          identifier
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetProfileDocument = gql`
    query GetProfile($slug: String!) {
  profile(slug: $slug) {
    ...Profile
  }
}
    ${ProfileFragmentDoc}`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
      }
export function useGetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
        }
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>;
export const GetSelfDocument = gql`
    query GetSelf {
  self {
    ...Profile
    company {
      ...Company
    }
  }
}
    ${ProfileFragmentDoc}
${CompanyFragmentDoc}`;

/**
 * __useGetSelfQuery__
 *
 * To run a query within a React component, call `useGetSelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSelfQuery(baseOptions?: Apollo.QueryHookOptions<GetSelfQuery, GetSelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelfQuery, GetSelfQueryVariables>(GetSelfDocument, options);
      }
export function useGetSelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelfQuery, GetSelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelfQuery, GetSelfQueryVariables>(GetSelfDocument, options);
        }
export type GetSelfQueryHookResult = ReturnType<typeof useGetSelfQuery>;
export type GetSelfLazyQueryHookResult = ReturnType<typeof useGetSelfLazyQuery>;
export type GetSelfQueryResult = Apollo.QueryResult<GetSelfQuery, GetSelfQueryVariables>;
export const JoinGroupDocument = gql`
    mutation JoinGroup($groupId: ID!) {
  joinGroup(groupId: $groupId) {
    invite {
      id
    }
    member {
      id
    }
  }
}
    `;
export type JoinGroupMutationFn = Apollo.MutationFunction<JoinGroupMutation, JoinGroupMutationVariables>;

/**
 * __useJoinGroupMutation__
 *
 * To run a mutation, you first call `useJoinGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinGroupMutation, { data, loading, error }] = useJoinGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useJoinGroupMutation(baseOptions?: Apollo.MutationHookOptions<JoinGroupMutation, JoinGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinGroupMutation, JoinGroupMutationVariables>(JoinGroupDocument, options);
      }
export type JoinGroupMutationHookResult = ReturnType<typeof useJoinGroupMutation>;
export type JoinGroupMutationResult = Apollo.MutationResult<JoinGroupMutation>;
export type JoinGroupMutationOptions = Apollo.BaseMutationOptions<JoinGroupMutation, JoinGroupMutationVariables>;
export const RejectGroupInviteDocument = gql`
    mutation RejectGroupInvite($inviteId: ID!) {
  rejectGroupInvite(inviteId: $inviteId)
}
    `;
export type RejectGroupInviteMutationFn = Apollo.MutationFunction<RejectGroupInviteMutation, RejectGroupInviteMutationVariables>;

/**
 * __useRejectGroupInviteMutation__
 *
 * To run a mutation, you first call `useRejectGroupInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectGroupInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectGroupInviteMutation, { data, loading, error }] = useRejectGroupInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useRejectGroupInviteMutation(baseOptions?: Apollo.MutationHookOptions<RejectGroupInviteMutation, RejectGroupInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectGroupInviteMutation, RejectGroupInviteMutationVariables>(RejectGroupInviteDocument, options);
      }
export type RejectGroupInviteMutationHookResult = ReturnType<typeof useRejectGroupInviteMutation>;
export type RejectGroupInviteMutationResult = Apollo.MutationResult<RejectGroupInviteMutation>;
export type RejectGroupInviteMutationOptions = Apollo.BaseMutationOptions<RejectGroupInviteMutation, RejectGroupInviteMutationVariables>;
export const RemoveCommentDocument = gql`
    mutation RemoveComment($blockId: ID!) {
  removeComment(blockId: $blockId) {
    id
  }
}
    `;
export type RemoveCommentMutationFn = Apollo.MutationFunction<RemoveCommentMutation, RemoveCommentMutationVariables>;

/**
 * __useRemoveCommentMutation__
 *
 * To run a mutation, you first call `useRemoveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommentMutation, { data, loading, error }] = useRemoveCommentMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useRemoveCommentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCommentMutation, RemoveCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCommentMutation, RemoveCommentMutationVariables>(RemoveCommentDocument, options);
      }
export type RemoveCommentMutationHookResult = ReturnType<typeof useRemoveCommentMutation>;
export type RemoveCommentMutationResult = Apollo.MutationResult<RemoveCommentMutation>;
export type RemoveCommentMutationOptions = Apollo.BaseMutationOptions<RemoveCommentMutation, RemoveCommentMutationVariables>;
export const RemoveGroupMemberDocument = gql`
    mutation RemoveGroupMember($groupId: ID!, $profileId: ID!) {
  removeGroupMember(groupId: $groupId, profileId: $profileId)
}
    `;
export type RemoveGroupMemberMutationFn = Apollo.MutationFunction<RemoveGroupMemberMutation, RemoveGroupMemberMutationVariables>;

/**
 * __useRemoveGroupMemberMutation__
 *
 * To run a mutation, you first call `useRemoveGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupMemberMutation, { data, loading, error }] = useRemoveGroupMemberMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useRemoveGroupMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupMemberMutation, RemoveGroupMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGroupMemberMutation, RemoveGroupMemberMutationVariables>(RemoveGroupMemberDocument, options);
      }
export type RemoveGroupMemberMutationHookResult = ReturnType<typeof useRemoveGroupMemberMutation>;
export type RemoveGroupMemberMutationResult = Apollo.MutationResult<RemoveGroupMemberMutation>;
export type RemoveGroupMemberMutationOptions = Apollo.BaseMutationOptions<RemoveGroupMemberMutation, RemoveGroupMemberMutationVariables>;
export const RemoveMatchDocument = gql`
    mutation RemoveMatch($matchId: ID!) {
  removeMatch(matchId: $matchId) {
    id
  }
}
    `;
export type RemoveMatchMutationFn = Apollo.MutationFunction<RemoveMatchMutation, RemoveMatchMutationVariables>;

/**
 * __useRemoveMatchMutation__
 *
 * To run a mutation, you first call `useRemoveMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMatchMutation, { data, loading, error }] = useRemoveMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useRemoveMatchMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMatchMutation, RemoveMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMatchMutation, RemoveMatchMutationVariables>(RemoveMatchDocument, options);
      }
export type RemoveMatchMutationHookResult = ReturnType<typeof useRemoveMatchMutation>;
export type RemoveMatchMutationResult = Apollo.MutationResult<RemoveMatchMutation>;
export type RemoveMatchMutationOptions = Apollo.BaseMutationOptions<RemoveMatchMutation, RemoveMatchMutationVariables>;
export const RequestAccountDocument = gql`
    mutation RequestAccount($name: String!, $email: String!, $username: String!) {
  requestAccount(name: $name, email: $email, username: $username)
}
    `;
export type RequestAccountMutationFn = Apollo.MutationFunction<RequestAccountMutation, RequestAccountMutationVariables>;

/**
 * __useRequestAccountMutation__
 *
 * To run a mutation, you first call `useRequestAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccountMutation, { data, loading, error }] = useRequestAccountMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useRequestAccountMutation(baseOptions?: Apollo.MutationHookOptions<RequestAccountMutation, RequestAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAccountMutation, RequestAccountMutationVariables>(RequestAccountDocument, options);
      }
export type RequestAccountMutationHookResult = ReturnType<typeof useRequestAccountMutation>;
export type RequestAccountMutationResult = Apollo.MutationResult<RequestAccountMutation>;
export type RequestAccountMutationOptions = Apollo.BaseMutationOptions<RequestAccountMutation, RequestAccountMutationVariables>;
export const UpdateBookmarkDocument = gql`
    mutation UpdateBookmark($groupId: ID!, $profileId: ID!) {
  updateBookmark(groupId: $groupId, profileId: $profileId)
}
    `;
export type UpdateBookmarkMutationFn = Apollo.MutationFunction<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>;

/**
 * __useUpdateBookmarkMutation__
 *
 * To run a mutation, you first call `useUpdateBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookmarkMutation, { data, loading, error }] = useUpdateBookmarkMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useUpdateBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>(UpdateBookmarkDocument, options);
      }
export type UpdateBookmarkMutationHookResult = ReturnType<typeof useUpdateBookmarkMutation>;
export type UpdateBookmarkMutationResult = Apollo.MutationResult<UpdateBookmarkMutation>;
export type UpdateBookmarkMutationOptions = Apollo.BaseMutationOptions<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($id: ID!, $input: UpdateGroupInput!) {
  updateGroup(id: $id, input: $input) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    ...Profile
  }
}
    ${ProfileFragmentDoc}`;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const OnContactCreatedDocument = gql`
    subscription OnContactCreated($profileId: ID!) {
  contactCreated(profileId: $profileId) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;

/**
 * __useOnContactCreatedSubscription__
 *
 * To run a query within a React component, call `useOnContactCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnContactCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnContactCreatedSubscription({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useOnContactCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnContactCreatedSubscription, OnContactCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnContactCreatedSubscription, OnContactCreatedSubscriptionVariables>(OnContactCreatedDocument, options);
      }
export type OnContactCreatedSubscriptionHookResult = ReturnType<typeof useOnContactCreatedSubscription>;
export type OnContactCreatedSubscriptionResult = Apollo.SubscriptionResult<OnContactCreatedSubscription>;
export const OnMatchDocument = gql`
    subscription OnMatch($profileId: ID!) {
  matched(profileId: $profileId) {
    ...Match
  }
}
    ${MatchFragmentDoc}`;

/**
 * __useOnMatchSubscription__
 *
 * To run a query within a React component, call `useOnMatchSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMatchSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMatchSubscription({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useOnMatchSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnMatchSubscription, OnMatchSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnMatchSubscription, OnMatchSubscriptionVariables>(OnMatchDocument, options);
      }
export type OnMatchSubscriptionHookResult = ReturnType<typeof useOnMatchSubscription>;
export type OnMatchSubscriptionResult = Apollo.SubscriptionResult<OnMatchSubscription>;